
import './App.css';
import Landing from './pages/Landing';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import Main from './pages/Main';
import Pricing from './pages/Pricing';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SharedQuiz from './pages/Shared-Quiz';
import TakeQuiz from './pages/TakeQuiz';
import { AuthProvider } from './contexts/AuthContext';
import Mission from './pages/Mission';
import MyLibrary from './pages/MyLibrary';
import StudyFlashcards from './pages/StudyFlashcards';
import StudyPlan from './pages/StudyPlan';
import Onboarding from './pages/Onboarding';
import ProtectedRoute from './components/ProtectedRoute';
import MyFiles from './pages/MyFiles';
import Notes from './pages/Notes';
import LayoutWithSidebars from './components/LayoutWithSidebars';
import SubpageLayout from './components/SubpageLayout';


function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/main/:uid" element={
            <ProtectedRoute>
              <Main />
            </ProtectedRoute>
          } />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/shared-quiz/:uid/:quizId" element={
            <ProtectedRoute>
              <SubpageLayout>
                <SharedQuiz />
              </SubpageLayout>
            </ProtectedRoute>
          } />
          <Route path="/take-quiz/:uid/:quizId" element={
            <ProtectedRoute>
              <SubpageLayout>
                <TakeQuiz />
              </SubpageLayout>
            </ProtectedRoute>
          } />
          <Route path="/mission" element={<Mission />} />
          <Route path="/my-library/:uid" element={
            <ProtectedRoute>
              <LayoutWithSidebars documents={[]} toggleFlashcards={() => {}} toggleQuiz={() => {}} toggleChat={() => {}}>
                <MyLibrary />
              </LayoutWithSidebars>
            </ProtectedRoute>
          } />
          <Route path="/study-flashcards/:uid/:flashcardId" element={
            <ProtectedRoute>
              <SubpageLayout>
                <StudyFlashcards />
              </SubpageLayout>
            </ProtectedRoute>
          } />
          <Route path="/study-plan" element={
            <ProtectedRoute>
              <LayoutWithSidebars documents={[]} toggleFlashcards={() => {}} toggleQuiz={() => {}} toggleChat={() => {}}>
                <StudyPlan />
              </LayoutWithSidebars>
            </ProtectedRoute>
          } />
          <Route path="/my-files/:uid" element={
            <ProtectedRoute>
              <LayoutWithSidebars documents={[]} toggleFlashcards={() => {}} toggleQuiz={() => {}} toggleChat={() => {}}>
                <MyFiles />
              </LayoutWithSidebars>
            </ProtectedRoute>
          } />
          <Route path="/notes/:uid/:noteId" element={
            <ProtectedRoute>
              <SubpageLayout>
                <Notes />
              </SubpageLayout>
            </ProtectedRoute>
          } />
          <Route path="/onboarding" element={<Onboarding />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
